/**
 * Topbar — Header sticky con título de página + widgets (créditos, IA,
 * cierre, mode toggles, notificaciones).
 * Extraído de DashboardLayout.jsx (iter.246 · Fase 8 UX Refactor).
 *
 * Props:
 *  - pageTitle: string a mostrar en el header.
 *  - onOpenMobileMenu: callback para abrir el sidebar en móvil.
 *  - currentRestaurant: para mostrar nombre y el ClosingStatusPill.
 *  - isStarter: para ocultar el pill de cierre en Starter.
 *  - creditInfo, creditBreakdown: props para CreditWidget.
 */
import { Menu } from "lucide-react";
import ClosingStatusTopbarPill from "../dashboard/ClosingStatusTopbarPill";
import { NotificationBell } from "../NotificationBell";
import { ThemeToggle } from "../theme/ThemeToggle";
import { ColorThemeToggle } from "../theme/ColorThemeToggle";
import { UIModeToggle } from "./UIModeToggle";
import { AIActivityIndicator } from "./AIActivityIndicator";
import { CreditWidget } from "./CreditWidget";

export function Topbar({
  pageTitle,
  onOpenMobileMenu,
  currentRestaurant,
  isStarter,
  creditInfo,
  creditBreakdown,
}) {
  return (
    <header
      className="h-16 border-b border-border bg-card/80 backdrop-blur-xl sticky top-0 z-30"
      /* z-stack-doc: L3 sticky topbar, coexists with FloatingOnboarding pill (bottom-left) */
    >
      <div className="h-full flex items-center justify-between px-4 lg:px-8">
        <button
          className="lg:hidden p-2 hover:bg-muted rounded-lg"
          onClick={onOpenMobileMenu}
          data-testid="mobile-menu-btn"
          aria-label="Abrir menú"
        >
          <Menu className="w-6 h-6" />
        </button>

        <div className="flex-1 lg:flex-none flex items-center gap-2">
          <h1 className="font-heading text-base lg:text-lg font-semibold truncate">
            {pageTitle || "Panel de Control"}
          </h1>
        </div>

        <div className="flex items-center gap-3">
          <AIActivityIndicator />
          <CreditWidget
            creditInfo={creditInfo}
            creditBreakdown={creditBreakdown}
          />
          {currentRestaurant && (
            <span className="text-sm text-muted-foreground hidden sm:block">
              {currentRestaurant.name}
            </span>
          )}
          {currentRestaurant?.restaurant_id && !isStarter && (
            <ClosingStatusTopbarPill
              restaurantId={currentRestaurant.restaurant_id}
            />
          )}
          <UIModeToggle />
          <ColorThemeToggle />
          <ThemeToggle />
          <NotificationBell />
        </div>
      </div>
    </header>
  );
}
